import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DxFormComponent } from 'devextreme-angular';
import { ToastrService } from 'ngx-toastr';
import { DeclineMessageModel } from 'src/app/models/decline-message.model';
import { ApprovalRequestService } from 'src/app/services/approval-request.service';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
  selector: 'app-decline-approval-request-modal',
  standalone: false,
  templateUrl: './decline-approval-request-modal.component.html',
  styleUrl: './decline-approval-request-modal.component.scss'
})
export class DeclineApprovalRequestModalComponent {
  @ViewChild('declineForm', { static: false }) 
  formComponent!: DxFormComponent;
  
  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();

  @Output() onCancel = new EventEmitter();
  @Output() onSend = new EventEmitter();

  @Input() approvalRequestId!: string;

  formData: DeclineMessageModel = { 
    reason: '' 
  };

  constructor(
    private toastrService: ToastrService,
    private loadingService: LoadingService,
    private translateService: TranslateService,
    private approvalRequestService: ApprovalRequestService,
  ) {

  }

  public onSendClick() {
    const isFormValid = this.formComponent.instance.validate().isValid;;

    if (!isFormValid) {
      this.toastrService.error(
        this.translateService.instant('VALIDATIONS.VALUES-NOT-VALID')
      );
      return;
    }
    
    this.loadingService
      .load(
        this.approvalRequestService.declineApprovalRequest(
          this.approvalRequestId,
          this.formData
        )
      )
      .subscribe({
        next: () => {
          this.toastrService.success(
            this.translateService.instant(
              'APPROVAL-REQUEST.DECLINE-MESSAGE.APPROVAL-REQUEST-DECLINED-SUCCESSFULLY'
            )
          );
          this.onSend.emit();
          this.close();
        },
        error: () => {
          this.toastrService.error(
            this.translateService.instant(
              'COMMON.AN-ERROR-HAS-OCCURRED'
            )
          );
        },
      });
  }

  public cancel() {
    this.onCancel.emit();
    this.close();
  }

  close() {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  }
}
